import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import useLanguageChange from "../../hooks/useLanguageChange";
import { CALL_BODY_SCREEN } from "../../constants/Constants";
import { setIsLiveLocationMapOpen } from "../../reducers/live-location-reducer";
import { isLiveLocationButtonIsVisible } from "../LiveLocation/LocationUtils";

const LiveLocationButton = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { currentCallBodyScreen, isRemoteParticipantJoined } = useSelector((state) => state.commonReducer);
    const { isLatLongDisable, isLiveLocationMapOpen } = useSelector((state) => state.liveLocation);

    const handleClickOnLiveLocation = () => {
        const ImageContainerDiv = document.querySelector(".saved-image-sidebar");
        if (ImageContainerDiv?.classList?.contains("active")) {
            const imageContainerToggleBtn = document.querySelector("#image-container-toggle-btn");
            imageContainerToggleBtn?.click();
        }

        dispatch(setIsLiveLocationMapOpen(!isLiveLocationMapOpen));
    };

    return (
        <>
            {isLiveLocationButtonIsVisible() && (
                <div className='action-button'>
                    <div className={clsx("action-button-in", isLatLongDisable && "custom-tooltip top-tooltip left-tooltip tooltip-auto-width")}>
                        <button
                            className={clsx("call-action-btn", isLiveLocationMapOpen && "active")}
                            disabled={!isRemoteParticipantJoined || currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN || isLatLongDisable}
                            onClick={handleClickOnLiveLocation}
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon icon-location'></span>
                            </span>
                            <span className='for-text'>{localisedValues["live_location"]}</span>
                        </button>
                        {isLatLongDisable && (
                            <div className='custom-tooltip-content text-nowrap'>
                                <div className='custom-tooltip-in'>
                                    <p>{localisedValues["no_one_shared_location"]}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default LiveLocationButton;
